import React, { useState } from "react";
import {getLoggedInUserName} from "../../apis/sessionUtil"
export default function UpdateProfile() {
    const [user, setUser] = useState({
        userName: getLoggedInUserName(),
        fullName: "",
        phone: "",
      });

  function onSubmit(){
    
    console.log();
   
  } 
  return (
    <form onSubmit={onSubmit}>
      <div className="row">
        <div className="col">

          <input
            type="text"
            disabled
            value={user.userName}
            className="ipc"
            name="userName"
          />
          <input
            type="text"
            defaultValue={user.fullName}
            className="ipc"
            name="fullName"
            placeholder="Full Name"
          />

          <input
            type="text"
            defaultValue={user.phone}
            className="ipc"
            name="phone"
            placeholder="Phone"
          />
        </div>
      </div>

      <div className="row">
        <div className="col">
          <button type="submit" className="ips ipc">
            Update Profile
          </button>
        </div>
      </div>

      
    </form>
  );
}
